import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Dashboard from '../views/Dashboard.vue';
import Login from '../views/Login.vue';
import { redirectToLogin } from '@/utils/auth'; // 导入工具函数
import { t } from '@/utils/i18nHelper'; // 导入多语言工具函数
import { getSessionStorage, setSessionStorage, getDevice } from '@/utils/util'; // 导入getSessionStorage方法和setSessionStorage方法
import * as dingding from '@/utils/dingding';
import store from '@/store';

Vue.use(VueRouter);

// 创建一个函数来获取路由配置，确保路由配置可以动态更新
function getRoutes() {
	return [
		{
			path: '/',
			component: Home,
			meta: {
				requireAuth: true,
			},
			children: [
				{
					path: '',
					redirect: '/reports',
				},
				{
					path: '',
					name: 'Dashboard',
					component: Dashboard,
					meta: {
						titleKey: 'home',
						requireAuth: true,
					},
				},
				{
					path: '/demo',
					name: 'Demo',
					component: () => import('../views/Demo.vue'),
					meta: {
						titleKey: 'demo',
						requireAuth: true,
					},
				},
				// {
				//   path: '/employees',
				//   name: 'Employees',
				//   component: () => import('../views/employees/EmployeeList.vue'),
				//   meta: {
				//     title: '员工列表',
				//     requireAuth: true
				//   }
				// },
				{
					path: '/createreport',
					name: 'CreateReport',
					component: () => import('../views/reports/CreateReport.vue'),
					meta: {
						titleKey: 'createNewReport',
						requireAuth: true,
					},
				},
				{
					path: '/reports',
					name: 'Reports',
					component: () => import('../views/reports/ReportsList.vue'),
					meta: {
						titleKey: 'reportManagement',
						requireAuth: true,
						showInMenu: true,
						icon: 'el-icon-document',
						order: 1,
						breadcrumb: [
							{ nameKey: 'home', path: '/' },
							{ nameKey: 'reportManagement', path: '' },
						],
					},
				},
				{
					path: '/oneline-report',
					name: 'OnelineReport',
					component: () => import('../views/reports/OnelineReport.vue'),
					meta: {
						titleKey: 'onelineReport',
						requireAuth: true,
						showInMenu: true,
						icon: 'el-icon-chat-line-square',
						order: 2,
						breadcrumb: [
							{ nameKey: 'home', path: '/' },
							{ nameKey: 'onelineReport', path: '' }
						]
					}
				},
				{
					path: '/reports/reportdetail/:id',
					name: 'ReportDetail',
					component: () => import('../views/reports/ReportsDetail.vue'),
					meta: {
						titleKey: 'reportDetail',
						breadcrumb: [
							{ nameKey: 'home', path: '/' },
							{ nameKey: 'reportManagement', path: '/reports' },
							{ nameKey: 'reportDetail', path: '' },
						],
					},
				},
				{
					path: '/templates',
					name: 'Templates',
					component: () => import('../views/templates/TemplatesList.vue'),
					meta: {
						titleKey: 'templateManagement',
						showInMenu: true,
						icon: 'el-icon-setting',
						order: 3,
						breadcrumb: [
							{ nameKey: 'home', path: '/' },
							{ nameKey: 'templateManagement', path: '' },
						],
					},
				},
				{
					path: '/reportList',
					name: 'reportList',
					component: () => import('../views/reportList/reportList.vue'),
					meta: {
						titleKey: 'reportManagement',
					},
				},
				{
					path: '/svgMaker',
					name: 'svgMaker',
					component: () => import('../views/svg/svgMaker.vue'),
					meta: {
						titleKey: 'svgmaker',
						requireAuth: true,
						showInMenu: true,
						icon: 'el-icon-document',
						order: 4,
					},
				},
				{
					path: '/svgEdit',
					name: 'svgEdit',
					component: () => import('../views/svgEdit/svgEdit.vue'),
					meta: {
						titleKey: 'svgEdit',
						requireAuth: true,
						showInMenu: false,
						icon: 'el-icon-document',
						order: 5,
					},
				},
				// {
				// 	path: '/mcp-test',
				// 	name: 'McpTest',
				// 	component: () => import('../views/mcp/McpTest.vue'),
				// 	meta: {
				// 		titleKey: 'mcpTest',
				// 		requireAuth: true,
				// 		showInMenu: true,
				// 		icon: 'el-icon-cpu',
				// 		order: 6,
				// 	},
				// },
				// {
				// 	path: '/history-session',
				// 	name: 'HistorySession',
				// 	component: () => import('../views/HistorySession/HistorySession.vue'),
				// 	meta: {
				// 		titleKey: '历史会话',
				// 		requireAuth: true,
				// 		showInMenu: true,
				// 		icon: 'el-icon-time',
				// 		order: 7,
				// 		breadcrumb: [
				// 			{ nameKey: 'home', path: '/' },
				// 			{ nameKey: '历史会话', path: '' }
				// 		]
				// 	}
				// },
				{
					path: '/intelligence-query',
					name: 'IntelligenceQuery',
					component: () => import('../views/intelligenceQuery/IntelligenceQuery.vue'),
					meta: {
						titleKey: 'intelligenceQuery',
						requireAuth: true,
						showInMenu: true,
						icon: 'el-icon-search',
						order: 8,
						breadcrumb: [
							{ nameKey: 'home', path: '/' },
							{ nameKey: 'intelligenceQuery', path: '' }
						]
					}
				},
				// {
				//   path: '/departments',
				//   name: 'Departments',
				//   component: () => import('../views/employees/DepartmentList.vue'),
				//   meta: {
				//     title: '部门管理',
				//     requireAuth: true
				//   }
				// },
				// {
				//   path: '/attendance',
				//   name: 'Attendance',
				//   component: () => import('../views/attendance/AttendanceList.vue'),
				//   meta: {
				//     title: '考勤记录',
				//     requireAuth: true
				//   }
				// },
				// {
				//   path: '/leave',
				//   name: 'Leave',
				//   component: () => import('../views/attendance/LeaveList.vue'),
				//   meta: {
				//     title: '请假管理',
				//     requireAuth: true
				//   }
				// },
				// {
				//   path: '/salary',
				//   name: 'Salary',
				//   component: () => import('../views/salary/SalaryList.vue'),
				//   meta: {
				//     title: '薪资发放',
				//     requireAuth: true
				//   }
				// },
				// {
				//   path: '/salary-structure',
				//   name: 'SalaryStructure',
				//   component: () => import('../views/salary/SalaryStructure.vue'),
				//   meta: {
				//     title: '薪资结构',
				//     requireAuth: true
				//   }
				// },
				// {
				//   path: '/settings',
				//   name: 'Settings',
				//   component: () => import('../views/settings/SystemSettings.vue'),
				//   meta: {
				//     title: '系统设置',
				//     requireAuth: true
				//   }
				// }
			],
		},
		{
			path: '/share/:id',
			name: 'shareDetail',
			component: () => import('../views/reports/ReportsDetail.vue'),
			meta: {
				requireAuth: false,
				titleKey: '分享报告',
			},
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
			meta: {
				titleKey: 'login',
				requireAuth: false,
			},
		},
		{
			path: '/auth-redirect',
			name: 'AuthRedirect',
			component: () => import('@/views/auth/AuthRedirect.vue'),
			meta: {
				requireAuth: false,
				title: 'AI情报',
				titleKey: 'AI情报',
			},
		},
		{
			path: '/h5',
			name: 'HomeH5',
			component: () => import('../views/h5/HomeH5.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/h5/detail/:id',
			name: 'ReportDetailH5',
			component: () => import('../views/reports/ReportsDetail.vue'),
			meta: {
				requireAuth: true,
			},
		},
		{
			path: '/deep-search-detail/:id',
			name: 'DeepSearchDetailH5',
			component: () => import('../views/h5/DeepSearchDetailH5.vue'),
			meta: {
				title: '规划模式详情',
				requireAuth: true
			}
		},
		{
			path: '/deep-search-ai-chat',
			name: 'DeepSearchAiChatH5',
			component: () => import('../views/h5/DeepSearchAiChatH5.vue'),
			meta: {
				title: '规划模式AI对话',
				requireAuth: true
			}
		},
		{
			path: '/h5/ai-report/:id',
			name: 'AiReportAiChatH5',
			component: () => import('../views/h5/AiReportH5.vue'),
			meta: {
				title: 'AI生成报告',
				requireAuth: true
			}
		},
		{
			path: '/h5/ai-report',
			name: 'AiReportAiChatH5',
			component: () => import('../views/h5/AiReportH5.vue'),
			meta: {
				title: 'AI生成报告',
				requireAuth: true
			}
		},
		{
			path: '/h5/ai-report-list',
			name: 'AiReportListH5',
			component: () => import('../views/h5/AiReportListH5.vue'),
			meta: {
				title: 'AI报告',
				requireAuth: true
			}
		},
		{
			path: '/cms-chat',
			name: 'CmsChat',
			component: () => import('../views/cmsChat/CmsChat.vue'),
			meta: {
				requireAuth: false,
				titleKey: 'cmsChat',
			},
		},
		{
			path: '/lctn-chat',
			name: 'LctnChat',
			component: () => import('../views/lctnChat/LctnChat.vue'),
			meta: {
				requireAuth: false,
				titleKey: 'lctnChat',
			},
		},
		{
			path: '/report-selector',
			name: 'ReportSelector',
			component: () => import('../views/reports/ReportSelector.vue'),
			meta: {
				requireAuth: false,
				titleKey: '选择报告',
			},
		},
	];
}

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes: getRoutes(),
});

// 添加更新语言函数，用于全局更新路由标题
export function updateRouteLanguage() {
	// 强制路由重新计算
	router.options.routes = getRoutes();
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
	
	const Device = getDevice(); // 识别环境
	// 检查用户是否登录
	const requireAuth = to.matched.some(record => record.meta.requireAuth);

	// 设置页面标题，使用翻译函数
	if (to.meta.titleKey) {
		document.title = t(to.meta.titleKey);
	}

	// 判断是否为本地环境
	if (process.env.NODE_ENV === 'development') {
		// 从 .env.user.js 中获取用户信息
		const userInfo = require('@/../.env.user.js');
		const { token, ...user } = userInfo;
		if (token && user) {
			// 将 token 和用户信息存储到 localStorage
			store.commit('SET_VALUE_BY_KEY', { key: 'token', value: token });
			store.commit('SET_VALUE_BY_KEY', { key: 'userInfo', value: user });
		}
	}
	//跳转自动登录页面
	if(to.path.includes('/auth-redirect')&&to.query.xgToken){
		next();
		return;
	}
	let token=to.query.xgToken||to.query.token;
	if(token){
		//判断访问链接中是否有token有的话换取用户信息
		store.dispatch('handleExternalLogin', token).then(({ success }) => {
			if (success) {
				// 清除URL中的token参数
				const newQuery = { ...to.query }
				delete newQuery.token
				delete newQuery.xgToken
				next({
					path: to.path,
					query: newQuery,
					replace: true
				})
			} else {
				//登录失败时跳转登录页面
				redirectToLogin();
			}
		}).catch(() => {
			//发生错误时也跳转登录页面
			redirectToLogin();
		});
		return;
	}
	const isAuthenticated = getSessionStorage('token');
	//钉钉环境并且没有登录时，可以获取code换取token
	let { corpId } = to.query;
	//测试环境钉钉环境没有corpId时，设置corpId
	if(Device.app === 'dingtalk' && !corpId && location.host == 'cwork-web-test.xgjktech.com.cn'){
		corpId = 'ding0b8223c4cde4879dee0f45d8e4f7c288';
	}
    if (corpId) {
		store.commit('SET_VALUE_BY_KEY', { key: 'corpId', value: corpId });
    }
	if(Device.app === 'dingtalk'){
		if(corpId&&!isAuthenticated){
			dingding.getCode(corpId, (code) => {
				console.log(code);
				// 3、再用code换取玄关token
				store.commit('SET_VALUE_BY_KEY', { key: 'code', value: code });
				dingding.getToken(corpId,code).then(({ success, data, data: { xgToken } }) => {
					console.log(success,data,xgToken);
					if (success) {
						if(!data.name&&data.userName){
							data.name = data.userName;
						}
						if(!data.dingUserId&&data.userId){
							data.dingUserId = data.userId;
						}
						store.commit('SET_VALUE_BY_KEY', { key: 'userInfo', value: data });
						store.commit('SET_VALUE_BY_KEY', { key: 'token', value: xgToken });
						// 4、在这里鉴权一次jsdk供整个工程使用
						dingding.jsApiConfig();
						setTimeout(() => {
							next();
						}, 100);
						return;
					}
				});
			});
		}else{
			next();
			return;
		}	
	}else{
		//非钉钉环境并且没有登录时，跳转登录页面
		if (requireAuth && !isAuthenticated) {
			redirectToLogin();
		} else {
			next();
		}
	}
});

export default router;
